import type { RenewalSummaryContent } from '@domain/schemas/renewal-summary.schema';

/**
 * The plain text Copy Text puts on the clipboard: the summary as the model
 * wrote it, which is already plain text (heading line, paragraph, "- "
 * bullets). The AI tag, timestamp and disclaimer are panel chrome and never
 * part of the text.
 */
export const buildCopyText = (content: RenewalSummaryContent): string => content.trim();
